import { IEntity } from "./IEntity";

export interface IDailySpend extends IEntity {
    transaction_date: string;
    credit_money: number;
    balance: number;
    expense_name: string;
    expense_amount: number;
    adjustment: boolean;
}

export const resourceNameDailySpend = `dailyspend`;
